export default "__VITE_ASSET__BSeLB4UE__"